<template>
  <q-page class="page-background column justify-center items-center">
    <div class="frosted q-pa-md column" style="max-width: 900px">
      <div class="text-h5 text-center q-mb-lg">Întrebări frecvente</div>
      <q-list bordered class="rounded-borders">
        
      </q-list>
    </div>
  </q-page>
</template>

<style lang="scss">
.page-background {
  background: url("../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.frosted {
  background: rgba(255, 255, 255, 0.678);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 3px solid rgba(255, 255, 255, 0.18);
}
</style>
